import i18n, { type AppLocale } from "../i18n";

export type AppTheme = "LIGHT" | "DARK";
export const kanbanPatterns = ["NONE", "DIAGONAL", "DOTS", "GRID", "CHECKER", "HORIZONTAL", "VERTICAL", "CROSSHATCH", "DIAMOND", "ZIGZAG"] as const;
export const kanbanColors = ["SLATE", "BLUE", "CYAN", "TEAL", "GREEN", "AMBER", "ORANGE", "RED", "VIOLET", "PINK"] as const;
export type KanbanPattern = typeof kanbanPatterns[number];
export type KanbanColor = typeof kanbanColors[number];
export type UserPreferences = { locale: AppLocale; theme: AppTheme; kanbanPattern: KanbanPattern; kanbanColor: KanbanColor };

export const kanbanStyleClass = (pattern: KanbanPattern = "NONE", color: KanbanColor = "SLATE") =>
  `kanban-pattern-${pattern.toLowerCase()} kanban-color-${color.toLowerCase()}`;

const THEME_KEY = "angelflow.theme";
const LOCALE_KEY = "angelflow.locale";

export function applyTheme(theme: AppTheme) {
  const value = theme === "DARK" ? "dark" : "light";
  document.documentElement.dataset.theme = value;
  document.documentElement.style.colorScheme = value;
  localStorage.setItem(THEME_KEY, theme);
}

export function applyLocale(locale: AppLocale) {
  document.documentElement.lang = locale;
  localStorage.setItem(LOCALE_KEY, locale);
  if (i18n.resolvedLanguage !== locale) void i18n.changeLanguage(locale);
}

export function applyPreferences(preferences: UserPreferences) {
  applyLocale(preferences.locale);
  applyTheme(preferences.theme);
}

export function bootstrapPreferences() {
  applyLocale(localStorage.getItem(LOCALE_KEY) === "en" ? "en" : "ko");
  applyTheme(localStorage.getItem(THEME_KEY) === "DARK" ? "DARK" : "LIGHT");
}
